import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

interface AddressCardProps {
  icon: LucideIcon;
  title: string;
  required?: boolean;
  /** The address dropdown / picker control. */
  control: ReactNode;
  /** Selected-address detail, custom-address form, or empty placeholder — rendered
   *  under a divider so it reads as belonging to this card's control. Omit to show
   *  no detail row. */
  detail?: ReactNode;
}

// 86d39epjt — bounded card that binds an address dropdown to its selected-address
// detail. Used by both the Shipping and Billing columns so the two render
// identically and the dropdown ↔ detail association is unambiguous. The card owns
// the header (so the inner control must NOT render its own label).
export function AddressCard({ icon: Icon, title, required, control, detail }: AddressCardProps) {
  return (
    <div className="space-y-2 rounded-md border bg-card p-3">
      <div className="flex items-center gap-2">
        <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
        <span className="text-sm font-medium">
          {title}
          {required && <span className="text-destructive"> *</span>}
        </span>
      </div>
      {control}
      {detail != null && <div className="border-t pt-2">{detail}</div>}
    </div>
  );
}
